<template>
    <b-modal ref="buildingCalculatedTableComparative" v-model="show" size="xl" title="ОБЪЕКТНИНГ ҚИЁСИЙ УСУЛИДА БАХОЛАШ КИЙМАТИНИ ХИСОБ - КИТОБИ" class="real-estate-building-calculations"
             :no-close-on-esc="true" :no-close-on-backdrop="true">
        <div class="container-fluid pl-0 pr-0" style="min-height: 500px;" v-if="data">
            <div class="row">
                <div class="col-12 table-responsive">
                    <div class="table-wrapper">
                        <table class="table">
                            <tbody>
                            <!--<tr class="bold-row">-->
                            <!--<td class="text-center" colspan="2">-->
                            <!--Объектнинг харажат усулида бахолаш кийматини хисоб - китоби-->
                            <!--</td>-->
                            <!--</tr>-->
                            <tr>
                                <td width="70%">Мулкдор:</td>
                                <td width="30%">
                                    <span v-if="data.realEstate && data.realEstate.owner && data.realEstate.owner.firmName">{{data.realEstate.owner.firmName}}</span>
                                    <span v-else-if="data.realEstate && data.realEstate.owner && data.realEstate.owner.fullName">{{data.realEstate.owner.fullName}}</span>
                                </td>
                            </tr>
                            <tr>
                                <td width="70%">Манзил:</td>
                                <td width="30%">
                                    {{(data.realEstate && data.realEstate.address) ? data.realEstate.address : ''}}
                                </td>
                            </tr>
                            <tr>
                                <td width="70%">Обеъкт номи:</td>
                                <td width="30%">{{(data.building && data.building.name) ? data.building.name : ''}}</td>
                            </tr>
                            <tr class="bold-row text-center">
                                <td colspan="2">
                                    Бинонинг кискача техник тавсифномаси
                                </td>
                            </tr>
                            <template v-if="data.fields">
                                <tr v-for="field in data.fields" :key="field.code">
                                    <td width="70%">{{field.name}}</td>
                                    <td width="30%">
                                        <span v-if="field.selected && field.selected.name">{{field.selected.name}}</span>
                                        <span v-else-if="field.valueAsLabel && field.valueAsLabel">{{field.valueAsLabel}}</span>
                                        <span v-else-if="field.value">{{field.value}}</span>
                                    </td>
                                </tr>
                            </template>
                            <template v-if="data.building">
                                <tr v-if="data.building.floors">
                                    <td width="70%">Каватлилиги</td>
                                    <td width="30%">{{data.building.floors ? (data.building.floors + ' кават') : ''}}</td>
                                </tr>
                                <tr v-if="data.building.height">
                                    <td width="70%">Бинонинг баландлиги</td>
                                    <td width="30%" class="text-right">{{data.building.height ? (data.building.height + ' м') : ''}}</td>
                                </tr>
                                <tr v-if="data.building.area">
                                    <td width="70%">Курилиш ости майдони</td>
                                    <td width="30%" class="text-right">{{data.building.area ? (data.building.area + ' м2') : ''}}</td>
                                </tr>
                                <tr v-if="data.building.volume">
                                    <td width="70%">Бинонинг хажми</td>
                                    <td width="30%" class="text-right">{{data.building.volume ? (data.building.volume + ' м3') : ''}}</td>
                                </tr>
                                <tr class="bold-row">
                                    <td>
                                        Бинонинг харажат усулида бахоланиш киймати
                                    </td>
                                    <td class="text-right">
                                          <span>
                                              {{data.building.calculated.price.totalAmount | currency('', 2, { thousandsSeparator: ' ' })}} сўм
                                          </span>
                                    </td>
                                </tr>
                            </template>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>

        <div slot="modal-footer" class="w-100 pt-3" style="border-top: 1px solid #CCCCCC">
            <button class="all-btn float-right mr-2" @click="close">
                OK
            </button>
        </div>
    </b-modal>
</template>

<script>
    import bModal from 'bootstrap-vue/es/components/modal/modal';
    import bModalDirective from 'bootstrap-vue/es/directives/modal/modal';
    export default {
        name: "NewRealEstateBuildingComparativeCalculatedView",
        components: {
            'b-modal': bModal
        },
        directives: {
            'b-modal': bModalDirective
        },
        props: {
            buildingId: Number,
        },
        data() {
            return {
                show: false,
                data: {}
            }
        },
        computed: {
            depreciationChangeFields() {
                let value = '';
                if (this.data.depreciationFields && this.data.depreciationFields.length > 0) {
                    this.data.depreciationFields.forEach((field) => {
                        if (field.change > 0) {
                            if (value.length > 0) value += ', ';
                            value += field.name + ': ' + field.change + '%'
                        }
                    })
                }
                if (value.length > 0) {
                    value += ' камайтирилди.'
                }
                return value
            },
        },
        methods: {
            close() {
                this.$refs.buildingCalculatedTableComparative.hide();
            }
        },
        created() {
            this.$eventBus.$on('showRealEstateBuildingComparativeCalculatedTable_' + this.buildingId, (data) => {
                this.data = data;
                this.show = true;
            });
        }
    }
</script>

<style>
    .real-estate-building-calculations .modal-dialog {
        max-width: 1100px;
        width: 1100px !important;
    }
    .real-estate-building-calculations .modal-content {
        width: 1100px !important;
    }
</style>
